import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import withAdminLayout from '../layout/withAdminLayout';
import { Spin } from 'antd';

const Dashboard = lazy(() => import('../container/dashboard/Index'));

const DashboardRoutes = () => {
    //const match = useMatch('/admin/profile/*'); // adjust to base route if different
    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spin />
                </div>
            }
        >
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
        </Suspense>
    );
}

export default withAdminLayout(DashboardRoutes);
